(function () {
  var ROOT_SELECTOR = "[data-perfume-vote]";
  var STORAGE_KEY = "pureamor-perfume-votes-v1";

  function loadState() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function saveState(state) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      // Ignore storage failures so the page stays usable.
    }
  }

  function getVoteRecord(state, itemId) {
    return state[itemId] || { vote: "", updatedAt: 0, upCount: 0, downCount: 0 };
  }

  function getStatusLabel(vote) {
    if (vote === "up") return "You liked this fragrance";
    if (vote === "down") return "You disliked this fragrance";
    return "No reaction yet";
  }

  function getSortScore(card, state) {
    var itemId = card.getAttribute("data-perfume-id");
    var record = getVoteRecord(state, itemId);

    if (record.vote === "up") return 1;
    if (record.vote === "down") return -1;
    return 0;
  }

  function updateCard(card, state) {
    var itemId = card.getAttribute("data-perfume-id");
    var record = getVoteRecord(state, itemId);
    var buttons = card.querySelectorAll("[data-vote-action]");
    var status = card.querySelector("[data-vote-status]");
    var upCount = card.querySelector('[data-vote-count="up"]');
    var downCount = card.querySelector('[data-vote-count="down"]');

    buttons.forEach(function (button) {
      var isActive = button.getAttribute("data-vote-action") === record.vote;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    if (status) {
      status.textContent = getStatusLabel(record.vote);
    }

    if (upCount) {
      upCount.textContent = String(record.upCount || 0);
    }

    if (downCount) {
      downCount.textContent = String(record.downCount || 0);
    }
  }

  function sortCards(root, state) {
    var sort = root.querySelector("[data-vote-sort]");
    var grid = root.querySelector("[data-vote-grid]");
    if (!sort || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-perfume-card]"));
    var mode = sort.value;

    cards.sort(function (a, b) {
      var seqA = parseInt(a.getAttribute("data-perfume-seq"), 10) || 0;
      var seqB = parseInt(b.getAttribute("data-perfume-seq"), 10) || 0;

      if (mode === "oldest") return seqA - seqB;

      if (mode === "popular") {
        var scoreDiff = getSortScore(b, state) - getSortScore(a, state);
        if (scoreDiff !== 0) return scoreDiff;
      }

      return seqB - seqA;
    });

    cards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function initVoteSection(root) {
    var state = loadState();

    root.querySelectorAll("[data-perfume-card]").forEach(function (card) {
      updateCard(card, state);
    });

    sortCards(root, state);

    root.addEventListener("change", function (event) {
      if (event.target.matches("[data-vote-sort]")) {
        sortCards(root, state);
      }
    });

    root.addEventListener("click", function (event) {
      var button = event.target.closest("[data-vote-action]");
      if (!button) return;

      var card = button.closest("[data-perfume-card]");
      if (!card) return;

      var itemId = card.getAttribute("data-perfume-id");
      var nextVote = button.getAttribute("data-vote-action");
      var currentRecord = getVoteRecord(state, itemId);
      var currentVote = currentRecord.vote;
      var upCount = currentRecord.upCount || 0;
      var downCount = currentRecord.downCount || 0;
      var finalVote = currentVote === nextVote ? "" : nextVote;

      if (currentVote === "up") {
        upCount = Math.max(0, upCount - 1);
      } else if (currentVote === "down") {
        downCount = Math.max(0, downCount - 1);
      }

      if (finalVote === "up") {
        upCount += 1;
      } else if (finalVote === "down") {
        downCount += 1;
      }

      state[itemId] = {
        vote: finalVote,
        updatedAt: Date.now(),
        upCount: upCount,
        downCount: downCount
      };

      saveState(state);
      updateCard(card, state);
      sortCards(root, state);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initVoteSection);
  });
})();
